import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const onClick = () => map.commands.exportReq({expBizFlag: '0'})

    return {
        key: 'export-dev-req1',
        label: '导出软件需求文档1',
        onClick,
    }
}
